<template>
  <div class="div-scroll">
    <el-card class="box-table">
      <div slot="header" class="btn-group">
        <div></div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
        @showDetail="handleToDetail"
      >
        <!-- <template slot="custom" slot-scope="scope">
          <el-button
            type="primary"
            @click="handleToDetail(scope.row)"
            class="leave-btn"
            >详情</el-button
          >
        </template> -->
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import Configs from "../data/train";
let mPage = MPage({
  pagePath: "/welcome-live/train/apply/listPage?status=3",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
export default {
  name: "",
  components: {
    CTable,
    TableBtns,
  },
  mixins: [mPage],
  data() {
    let { tableColumnsAudit } = Configs(this);
    return {
      SUCCESS_CODE: "",
      tableColumns: tableColumnsAudit,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {},
  methods: {
    selectionChange() {},
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 查看详情
    handleToDetail(data) {
      // this.$router.push("/welcome/teacher/predicted/trainDetail/todo/" + data.id);
      this.$router.push({path:"/welcome/teacher/predicted/trainDetail",query:{id:data.id,type:'todo'}});
    },
  },
};
</script>
